export default "/_next/static/chunks/fonts/Montserrat-ExtraBold-latin-56a4263955f161c9f6fb419729153484.woff2";